import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import getUrl from 'libraries/front-end-core/core/url'
import { PRECEDENTS_ALL, DOCUMENTS_MENU } from 'constants/controllers'
import Loading from 'components/shared/Loading'

export default new Controller({
  name: PRECEDENTS_ALL,
  route: '(:aol/)precedents/:view/all',
  controller (Router, { url, params: { aol, view } }, render) {
    const pageId = getUrl(PRECEDENTS_ALL, { aol, view })

    replaceUrl(
      getUrl(DOCUMENTS_MENU)
    )

    render(
      { Main: Loading },
      {
        view,
        aol: null // Documents no longer use AOL
      },
      {
        searchType: 'precedents',
        className: 'precedents',
        pageId,
        aol: null // Documents no longer use AOL
      }
    )

    return pageId
  }
})
